import { H3 } from '@h3/types';

/** 获取插件列表 */
export const PluginList = '/v1/plugin/list';
/** OCR插件调用 */
export const PluginInvoke = '/v1/plugin/ocr/recognize';
/** ocr识别剩余次数 */
export const CheckAvailableOcr = '/v1/plugin/ocr/CheckAvailable';
/** 添加插件 */
export const PluginAdd = '/v1/plugin/add';
/** 删除插件 */
export const PluginRemove = '/v1/plugin/remove';

/** 获取第三方连接 */
export const ConnectConfigList = '/v1/plugin/connection/connectionconfiglist';
/** 新增第三方连接 */
export const ConnectConfigAdd = '/v1/plugin/connection/addConnectionconfig';
/** 编辑更新第三方连接 */
export const ConnectConfigUpdate = '/v1/plugin/connection/updateconnectionconfig';
/** 新增第三方连接(编码模式) */
export const ConnectCodingConfigAdd = '/v1/plugin/connection/addconnectioncodingconfig';
/** 编辑第三方连接(编码模式) */
export const ConnectCodingConfigUpdate = '/v1/plugin/connection/updateconnectioncodingconfig';
/** 删除第三方连接 */
export const ConnectConfigDelete = '/v1/plugin/connection/deleteconnectionconfig';
/** 获取第三方连接详情 */
export const ConnectConfigDetail = '/v1/plugin/connection/connectionconfigdetail';
/** 禁用启用第三方连接 */
export const ConnectConfigStatus = '/v1/plugin/connection/setconnectionconfigstatus';
/** 执行或者调试第三方连接 */
export const ConnectionConfigInvoke = '/v1/plugin/connection/invokeconnectionconfig';
/** 查看当前连接的表单使用情况 */
export const ConnectionUsageList = '/v1/plugin/connection/getConnectionUsageList';

export const EsignApi = {
    [H3.Plugin.EsignType.CommonEsign]: {
        /** 获取电子签章绑定关系 */
        EsignBizObjectTask: '/v1/plugin/esign/getesignbizobjecttask',
        /** 获取流程签署详细信息 */
        EsignFlowSignDetail: '/v1/plugin/commonesign/detail',
        /** 获取签署人签署地址 */
        EsignNoticeUrl: '/v1/plugin/commonesign/url',
        /** 通过taskid获取签署完成的文件 */
        EsignBizObjectDocs: '/v1/plugin/commonesign/syncfile',
        /** 获取文件上传地址 */
        EsignUploadUrl: '/v1/plugin/esign/getuploadurlbyattachmentIds',
        /** 获取发起签署任务地址 */
        EsignProcessStartUrl: '/v1/plugin/esign/getprocessstarturl',
        /** 获取个人/组织认证地址 */
        EsignAuthUrl: '/v1/plugin/commonesign/authurl',
        /** 获取电子签章模板 */
        EsignTemplate: '/v1/plugin/commonesign/template',
    },
    [H3.Plugin.EsignType.DingtalkEsign]: {
        /** 获取电子签章绑定关系 */
        EsignBizObjectTask: '/v1/plugin/esign/getesignbizobjecttask',
        /** 获取流程签署详细信息 */
        EsignFlowSignDetail: '/v1/plugin/esign/getflowsigndetail',
        /** 获取签署人签署地址 */
        EsignNoticeUrl: '/v1/plugin/esign/getsignnoticeurl',
        /** 通过taskid获取签署完成的文件 */
        EsignBizObjectDocs: '/v1/plugin/esign/getbizobjectdocs',
        /** 获取文件上传地址 */
        EsignUploadUrl: '/v1/plugin/esign/getuploadurlbyattachmentIds',
        /** 获取发起签署任务地址 */
        EsignProcessStartUrl: '/v1/plugin/esign/getprocessstarturl',
        /** 获取个人/组织认证地址 */
        EsignAuthUrl: '/v1/plugin/commonesign/authurl',
        /** 获取电子签章模板 */
        EsignTemplate: '/v1/plugin/commonesign/template',
    },
};

/** 获取邮件配置 */
export const GetEmailConfig = '/v1/plugin/email/getemailconfig';
/** 设置邮件配置 */
export const SetEmailConfig = '/v1/plugin/email/settingemailconfig';
/** 删除邮件配置 */
export const RemoveEmailConfig = '/v1/plugin/email/removeemailconfig';
/** 发送邮件 */
export const SendEmails = '/v1/plugin/email/send';

/** 获取氚云短信模板列表 */
export const SmsTemplateList = '/v1/plugin/sms/template/list';
/** 获取第三方短信模板列表 */
export const ThirdpartySmsTemplateList = '/v1/plugin/sms/thirdparty/template/list';
/** 删除短信模板 */
export const SmsTemplateRemove = '/v1/plugin/sms/template/remove';
/** 发送短信 */
export const SendSms = '/v1/plugin/sms/send';
/** 获取短信服务商配置 */
export const SmsConfig = '/v1/plugin/sms/config/list';
/** 获取短信签名列表 */
export const ThirdpartySmsSign = '/v1/plugin/sms/thirdparty/sign/list';

/** 查询考勤 */
export const DingTalkAttendanceDetail = '/v1/plugin/dingtalkattendance/getattendancedetail';
/** 查询打卡 */
export const DingTalkAttendanceClock = '/v1/plugin/dingtalkattendance/getattendancelist';
/** 查询请假 */
export const DingTalkAttendanceVacate = '/v1/plugin/dingtalkattendance/getleavetimebynames';
/** 发送消息至会话 */
export const DingTalkAttendanceSessionsChat = '/v1/plugin/dingtalkattendance/sendcropchat';
/** 发送消息至钉钉机器人 */
export const DingTalkAttendanceRobotChat = '/v1/plugin/dingtalkattendance/sendrobotchat';

/** 查询在线支付插件授权信息 */
export const PaymentAliPayAuthInfo = '/v1/plugin/payment/AliPayAuthInfo';
/** 发起支付 */
export const PaymentAliPayCreate = '/v1/plugin/payment/AliPayPreCreate';
/** 查询支付状态 */
export const PaymentAliPayTradeQuery = '/v1/plugin/payment/AliPayTradeQuery';
/** 交易关闭 */
export const PaymentAliPayTradeClose = '/v1/plugin/payment/AliPayTradeClose';
/** 交易退款 */
export const PaymentAliPayTradeRefund = '/v1/plugin/payment/AliPayTradeRefund';

/** 获取人脸识别插件配置信息 */
export const GetFaceRecognitionConfig = '/v1/plugin/facerecognition/getFaceConfig';
/** 保存人脸识别授权账号配置 */
export const SaveFaceRecognitionAuthorize = '/v1/plugin/facerecognition/saveFaceAuthorizeInfo';
/** 获取人脸识别人员库列表 */
export const GetFaceRecognitionPersonGroupInfo = '/v1/plugin/facerecognition/getPersonGroupInfos';
/** 保存人脸识别人员库 */
export const CreateFaceRecognitionPersonGroup = '/v1/plugin/facerecognition/createPersonGroup';
/** 取消人脸识别授权 */
export const CancelFaceRecognitionConfigAuthorize = '/v1/plugin/facerecognition/cancelApiSecretAuthorize';

/** 发送机器人消息 */
export const SendRobotNotification = '/v1/plugin/sendRobotNotification';
/** 群机器人测试 */
export const VerifyRobotNotification = '/v1/toolkit/notification/chatbot/verify';

/** 获取含有企微会话存档记录的人员列表 */
export const sendsides = '/v1/plugin/wxworkchat/sendsides/query';
/** 根据人员获取存在的会话记录 */
export const receivesides = '/v1/plugin/wxworkchat/receivesides/query';

/** 会话记录消息列表 */
export const chatrecord = '/v1/plugin/wxworkchat/chatmessage/query';

/** 导出会话记录 */
export const exportChatMessage = '/v1/plugin/wxworkchat/chatmessage/export';

/** 授权会话导出任务 */
export const authorizeExportChatMessage = '/v1/plugin/wxworkchat/chatmessage/export/job';

/** 查询会话导出记录 */
export const exportChatMessageRecords = '/v1/plugin/wxworkchat/chatmessage/export/records/query';

/** 根据消息id获取上下聊天记录 */
export const getChatrecordByMessId = '/v1/plugin/wxworkchat/chatmessage/query/locate';

/** 同步会话记录 */
export const asyncChatrecord = '/v1/plugin/wxworkchat/chatsession/sync';

/** 会话总结 */
export const chatSummary = '/v1/plugin/wxworkchat/job/summary';

/** 会话总结进度 */
export const getChatSummaryResult = '/v1/plugin/wxworkchat/result/summary';

/** 会话配置 */
export const getchatConfig = '/v1/plugin/wxworkchat/config';

/** 顶群列表绑定的业务数据 */
export const getBizDataBySceneGroupId = '/v1/plugin/scenegroup/bizdata';

/** 获取dataspeak授权用户 */
export const getDataSpeakUser = '/v1/plugin/dataspeak/user';

/** 获取dataspeak的 License */
export const getDataSpeakLicense = '/v1/plugin/dataspeak/limit';

/** 校验dataspeak用户授权 */
export const checkDataSpeakUserAuthorization = '/v1/plugin/dataspeak/scope/user/check';
